import { noop } from 'lodash';

const perf = {
  mark:
    (typeof window === 'object' &&
      window &&
      window.performance &&
      window.performance.mark &&
      window.performance.mark.bind(window.performance)) ||
    noop,
  measure:
    (typeof window === 'object' &&
      window &&
      window.performance &&
      window.performance.measure &&
      window.performance.measure.bind(window.performance)) ||
    noop,
};

export default perf;
